import { PointOfPurchaseShopViewModel, ProductListViewModel } from '@/types/api'
import { ProductViewModel } from '@/types/cml-api'

import { PDPCardProps } from '../types'

export const generateHomePageProductsListItem = (product: ProductViewModel): PDPCardProps => ({
    brand: product.brand?.nameFa || product.brand?.nameEn || '',
    name: product.nameFa || product.nameEn || '',
    id: product.id || '',
    image: product.mainImageUrl || '',
    slug: product.slug || '',
    pricingProps: {
        basePrice: product.basePrice || 0,
        discountPercent: product.discountPercent || 0,
        effectivePrice: product.salesPrice || 0,
    },
    type: 'vertical',
    isSalable: product.isSalable || false,
})

export const generatePOProps = (data: PointOfPurchaseShopViewModel): PDPCardProps => ({
    id: data.atpId || '',
    atpId: data?.atpId || '',
    itemProposalId: data?.itemProposalId || '',
    slug: '',
    pricingProps: {
        basePrice: data?.basePrice,
        discountPercent: data.discountPercent,
        effectivePrice: data.salesPrice,
    },
    brand: data?.brandName || '',
    name: data?.productName || '',
    image: data?.productImageUrl || '',
    isSalable: true,
    type: 'vertical',
    showDirectAddToCart: true,
})

export const generatePDPPageCarouselItemsProps = (
    product: ProductListViewModel,
    type: PDPCardProps['type']
): PDPCardProps => ({
    brand: product.brand?.nameFa || product.brand?.nameEn || '',
    name: product.nameFa || product.nameEn || '',
    id: product.id || '',
    image: product.imageUrl || '',
    slug: product.slug || '',
    pricingProps: {
        basePrice: product.basePrice || 0,
        discountPercent: product.discountPercent || 0,
        effectivePrice: product.effectivePrice || 0,
    },
    isSalable: product.isSalable || false,
    type,
})
